<div class="p-1 flex" *transloco="let t">
	<button
		id="undo"
		class="h-7 w-7 flex items-center justify-center border-none rounded-md hover:text-white hover:bg-black"
		[matTooltip]="t('araEditor.undo')"
		[disabled]="!editor().can().undo()"
		[ngClass]="{ 'text-white bg-black': this.editor().isActive('undo') }"
		(click)="editor().chain().focus().undo().run()">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
			<path
				fill="currentColor"
				d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88c3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8" />
		</svg>
	</button>
	<button
		id="redo"
		class="h-7 w-7 flex items-center justify-center border-none rounded-md hover:text-white hover:bg-black"
		[matTooltip]="t('araEditor.redo')"
		[ngClass]="{ 'text-white bg-black': this.editor().isActive('redo') }"
		[disabled]="!editor().can().redo()"
		(click)="editor().chain().focus().redo().run()">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
			<path
				fill="currentColor"
				d="M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16a8.002 8.002 0 0 1 7.6-5.5c1.95 0 3.73.72 5.12 1.88L13 16h9V7z" />
		</svg>
	</button>
	<!-- Add a Divider Line -->
	<!--  <div class="-->
	<!--      h-8-->
	<!--      w-8-->
	<!--      flex-->
	<!--      items-center-->
	<!--      justify-center-->
	<!--      border-none-->
	<!--      rounded-md">-->
	<!--    <svg-->
	<!--      xmlns="http://www.w3.org/2000/svg"-->
	<!--      viewBox="0 0 24 24"-->
	<!--      height="32"-->
	<!--      fill="currentColor">-->
	<!--      <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"-->
	<!--            d="M12 19V5"/>-->
	<!--    </svg>-->
	<!--  </div>-->
	<button
		id="bold"
		class="h-7 w-7 flex items-center justify-center border-none rounded-md hover:text-white hover:bg-black"
		[matTooltip]="t('araEditor.bold')"
		(click)="editor().chain().focus().toggleBold().run()"
		[ngClass]="{ 'text-white bg-black': this.editor().isActive('bold') }">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
			<path fill="none" d="M0 0h24v24H0z" />
			<path
				d="M8 11h4.5a2.5 2.5 0 1 0 0-5H8v5zm10 4.5a4.5 4.5 0 0 1-4.5 4.5H6V4h6.5a4.5 4.5 0 0 1 3.256 7.606A4.498 4.498 0 0 1 18 15.5zM8 13v5h5.5a2.5 2.5 0 1 0 0-5H8z" />
		</svg>
	</button>
	<button
		id="underline"
		class="ml-1 h-7 w-7 flex items-center justify-center border-none rounded-md hover:text-white hover:bg-black"
		[matTooltip]="t('araEditor.underline')"
		(click)="editor().chain().focus().toggleUnderline().run()"
		[ngClass]="{ 'text-white bg-black': this.editor().isActive('underline') }">
		<svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
			<g>
				<path fill="none" d="M0 0h24v24H0z"></path>
				<path d="M8 3v9a4 4 0 1 0 8 0V3h2v9a6 6 0 1 1-12 0V3h2zM4 20h16v2H4v-2z"></path>
			</g>
		</svg>
	</button>
	<button
		id="italic"
		class="ml-1 h-7 w-7 flex items-center justify-center border-none rounded-md hover:text-white hover:bg-black"
		[matTooltip]="t('araEditor.italic')"
		(click)="editor().chain().focus().toggleItalic().run()"
		[ngClass]="{ 'text-white bg-black': this.editor().isActive('italic') }">
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
			<path fill="none" d="M0 0h24v24H0z" />
			<path d="M15 20H7v-2h2.927l2.116-12H9V4h8v2h-2.927l-2.116 12H15z" />
		</svg>
	</button>
</div>
